export const LineBreak = () => <div className="DsPreviewJson-LineBreak" />;
